export default __webpack_public_path__ + "static/media/Group1462101.4426de75.svg";